import React, { useState } from 'react';
import DialogComponent from '../dialog/dialog.component';
import { Delete } from 'lucide-react';
import { postService } from '../../services/post.service';
import toast from 'react-hot-toast';

interface ConfirmReactPostProps {
  postId?: string;
  removePost?: any;
}

const DeletePost = ({ postId, removePost }: ConfirmReactPostProps) => {
  const [visible, setVisible] = useState(false);

  const onClose = () => {
    setVisible(false);
  };
  const onConfirm = async () => {
    await postService.deletePost(postId);
    toast.success('Đã xóa bài viết');
    setVisible(false);
    removePost(postId);
  };

  return (
    <div>
      <button
        onClick={() => setVisible(true)}
        className="rounded-md flex items-center gap-2 w-full px-4 py-2 hover:bg-gray-200 dark:hover:bg-gray-10 "
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21.0699 5.23C19.4599 5.07 17.8499 4.95 16.2299 4.86V4.85L16.0099 3.55C15.8599 2.63 15.6399 1.25 13.2999 1.25H10.6799C8.34991 1.25 8.12991 2.57 7.96991 3.54L7.75991 4.82C6.82991 4.88 5.89991 4.94 4.96991 5.03L2.92991 5.23C2.50991 5.27 2.20991 5.64 2.24991 6.05C2.28991 6.46 2.64991 6.76 3.06991 6.72L5.10991 6.52C10.3499 6 15.6299 6.2 20.9299 6.73C20.9599 6.73 20.9799 6.73 21.0099 6.73C21.3899 6.73 21.7199 6.44 21.7599 6.05C21.7899 5.64 21.4899 5.27 21.0699 5.23Z"
            fill="#657384"
          />
          <path
            d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14ZM13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75ZM14.5 13.75H9.49999C9.08999 13.75 8.74999 13.41 8.74999 13C8.74999 12.59 9.08999 12.25 9.49999 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
            fill="#657384"
          />
        </svg>

        <span className="text-base font-normal text-[#18191E]">Xóa bài viết</span>
      </button>
      <DialogComponent visible={visible} onClose={onClose} placement="CENTER">
        <div className="mt-2 p-6">
          <p className="text-slate-800 dark:text-slate-50 text-base font-medium">
            Bạn muốn xóa bài viết này?
          </p>

          <div className="flex justify-end gap-3 mt-5">
            <button
              className="text-slate-800  dark:text-slate-50 px-4 py-2 rounded-md border border-solid border-slate-500 text-sm cursor-pointer font-medium"
              onClick={onClose}
            >
              Đóng
            </button>
            <button
              className="px-4 py-2 rounded-md bg-primary text-slate-50 text-sm cursor-pointer font-medium"
              onClick={onConfirm}
            >
              Đồng ý
            </button>
          </div>
        </div>
      </DialogComponent>
    </div>
  );
};

export default DeletePost;
